/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantNineToTenMonthOld } from './InfantNineToTenMonthOld';
import {
    InfantNineToTenMonthOldFromJSON,
    InfantNineToTenMonthOldFromJSONTyped,
    InfantNineToTenMonthOldToJSON,
} from './InfantNineToTenMonthOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantNineToTenMonthOldPagination
 */
export interface InfantNineToTenMonthOldPagination {
    /**
     * 
     * @type {Array<InfantNineToTenMonthOld>}
     * @memberof InfantNineToTenMonthOldPagination
     */
    data?: Array<InfantNineToTenMonthOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantNineToTenMonthOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantNineToTenMonthOldPagination interface.
 */
export function instanceOfInfantNineToTenMonthOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantNineToTenMonthOldPaginationFromJSON(json: any): InfantNineToTenMonthOldPagination {
    return InfantNineToTenMonthOldPaginationFromJSONTyped(json, false);
}

export function InfantNineToTenMonthOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantNineToTenMonthOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantNineToTenMonthOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantNineToTenMonthOldPaginationToJSON(value?: InfantNineToTenMonthOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantNineToTenMonthOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

